import {
    put,
    select,
    call
} from 'redux-saga/effects';
import {
    debug,
    error
} from '../utils/logger';
import { randomizeBanner } from '../actions/initialActions.js';
import apiRoutes from '../utils/apiRoutes';
import { makeRequest } from './makeRequest';
import { receiveGenericPromoBanner } from '../actions/promoBannerActions.js';

export function* randomizeFooterPromoSaga() {
    debug('Saga: randomizeFooterPromoSaga initialized');
    let state = yield select();
    const banners = _.get(state, 'core.secondaryFooterPromos.banners', []);

    if (banners.length > 0) {
        yield put(randomizeBanner(banners[Math.floor(Math.random() * banners.length)]));
    }
}

/**
 * Fetch updated promo banner data from contentful orchestration
 * Fires action to update store with banner information
 * @param  {Array} promoTypes list of promo types to fetch results for
 */
export function* getPromoBannersSaga(promoTypes = []) {
    const state = yield select();

    for (const promo in promoTypes) {
        try {
            const route = apiRoutes.orchestrationPromoBanners(state, promoTypes[promo].type);
            const res = yield call(makeRequest, route);

            yield put(receiveGenericPromoBanner(res, promoTypes[promo].key));
        } catch (err) {
            error('getPromoBannersSaga:', err);
        }
    }
}

export default [

];
